import PropTypes from 'prop-types';
import React from 'react';

const ViewTransactionButton = ({ transaction, onView }) => {
  const handleClick = (event) => {
    event.stopPropagation();
    onView(transaction);
  };

  return (
    <button
      type="button"
      className="table__view-btn"
      data-testid="view-transaction-btn"
      onClick={handleClick}
    >
      View details
    </button>
  );
};

ViewTransactionButton.propTypes = {
  transaction: PropTypes.object.isRequired,
  onView: PropTypes.func.isRequired
};

export { ViewTransactionButton };
